import React, { useState } from "react"
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, Grid, IconButton, ThemeProvider, Typography } from "@material-ui/core"
import { Check, Close } from "@material-ui/icons"
// import { Notification } from "@/components"
import { renderComponent } from "@/utils/node"
import { whatsappLinks } from "@/utils/link"

// import AccountService from "@/services/Account"

import upsellDialogImg from "@/assets/images/upsell-dialog-img.png"

import theme from "@/styles/theme"
import useStyles from "@/components/UpsellDialog/UpsellHandlerDialog/styles"
import UpsellSuccessfullyCompleted from "@/components/UpsellDialog/UpsellHandlerDialog/UpsellSuccessfullyCompleted"
import { isDevEnv } from "@/utils/environment"

import { UpsellPermissionType } from "@/protocols/planAddons"

type UpsellHandlerDialogProps = {
	type: UpsellPermissionType
}

type UpsellTypeToResourceInfo = {
	id: number
	name: string
	quantity: number
}

type UpsellTypeToUpsellHandlerDialogContentProps = Record<UpsellPermissionType, {
	title: string
	description: string
	descriptionLink?: string
	resourceDescription: string
	benefits: string[]
	resource: UpsellTypeToResourceInfo
}>

type UpsellHandlerDialogType = {
	open: (props: UpsellHandlerDialogProps) => void
}

export const UPSELL_HANDLER_DIALOG_CONTENT: UpsellTypeToUpsellHandlerDialogContentProps = {
	"ai-text-enhancement-limit-reached-admin": {
		title: "Continue otimizando o seu atendimento com IA",
		description: "O seu time atingiu o limite de créditos de IA. Continue otimizando respostas, usando os blocos inteligentes no bot, ajustando o tom e melhorando os textos das mensagens. Mantenha sua equipe produtiva e suas conversas cada vez mais eficazes com a força da inteligência artificial.",
		benefits: [
			"Aprimore suas mensagens com textos claros e impactantes, ajuste o tom para se conectar melhor com seu público e comunique sem erros.",
			"Crie blocos de condição e intenção com IA para tornar seus fluxos mais inteligentes e eficientes.",
			"E muito mais..."
		],
		// resourceDescription: "Adicione nossos Créditos de IA na sua instância por apenas R$ 197,00.",
		resourceDescription: "",
		resource: {
			id: isDevEnv ? 51 : 27,
			name: "IA",
			quantity: 1500
		}
	},
	"ai-credits-limit-reached": {
		title: "Continue otimizando o seu atendimento com IA",
		description: "O seu time atingiu o limite de créditos de IA. Continue otimizando respostas, usando os blocos inteligentes no bot, resumindo atendimentos, ajustando o tom e melhorando os textos das mensagens. Mantenha sua equipe produtiva e suas conversas cada vez mais eficazes com a força da inteligência artificial.",
		benefits: [
			"Aprimore suas mensagens com textos claros e impactantes, ajuste o tom para se conectar melhor com seu público e comunique sem erros.",
			"Crie blocos de condição e intenção com IA para tornar seus fluxos mais inteligentes e eficientes.",
			"Resumir atendimentos com IA para insights rápidos e eficazes.",
			"E muito mais..."
		],
		// resourceDescription: "Adicione nossos Créditos de IA na sua instância por apenas R$ 197,00.",
		resourceDescription: "",
		resource: {
			id: isDevEnv ? 51 : 27,
			name: "IA",
			quantity: 1500
		}
	}
}

const UpsellHandlerDialog: UpsellHandlerDialogType & React.FC<UpsellHandlerDialogProps> = (props) => {
	const [isDialogOpen, setIsDialogOpen] = useState(true)
	const [loading] = useState(false)
	const [success] = useState(false)

	const classes = useStyles()

	const { type } = props
	const dialogContent = UPSELL_HANDLER_DIALOG_CONTENT[type as UpsellPermissionType]

	// const handleCreatePlanAddonInAccount = async () => {
	// 	setLoading(true)
	// 	try {
	// 		await AccountService.createPlanAddonsInAccount({
	// 			planAddon: {
	// 				id: UPSELL_HANDLER_DIALOG_CONTENT[type as UpsellPermissionType].resource.id,
	// 				name: UPSELL_HANDLER_DIALOG_CONTENT[type as UpsellPermissionType].resource.name,
	// 				priceInCents: 19700
	// 			},
	// 			createdBy: "user",
	// 			isUserReachSubscriptionLimit: true,
	// 			upsellType: "ai-text-enhancement-limit-reached-admin"
	// 		})
	// 		setSuccess(true)
	// 		Notification.success({
	// 			message: "Contratação realizada com sucesso!"
	// 		})
	// 	} catch (error) {
	// 		Notification.error({
	// 			message: "Houve um erro ao contratar o adicional!"
	// 		})
	// 		setSuccess(false)
	// 	} finally {
	// 		setLoading(false)
	// 	}
	// }

	const handleCloseDialog = () => {
		setIsDialogOpen(false)
	}

	// const handleSaveDialog = async () => {
	// 	await handleCreatePlanAddonInAccount()
	// }

	const handleRedirectToSubscriptionTeam = () => {
		window.open(whatsappLinks.sendMessageToAcquireAdditionalAIResources, "_blank")
	}

	return (
		<ThemeProvider theme={theme}>
			<Dialog
				open={isDialogOpen}
				onClose={handleCloseDialog}
				maxWidth="md"
				fullWidth
			>
				<DialogContent className={classes.dialogContent}>
					<Grid container>
						{success ? (
							<Grid item md={8}>
								<UpsellSuccessfullyCompleted upsellDescription={dialogContent.resource.name} upsellQuantity={dialogContent.resource.quantity} onClose={handleCloseDialog} />
							</Grid>
						) : (
							<Grid md={8} item>
								<Typography variant="h3" className={classes.dialogTitle}>
									{dialogContent.title}
								</Typography>
								<DialogContentText className={classes.dialogDescription}>
									{dialogContent.description} {dialogContent.descriptionLink && (
										<a href={dialogContent.descriptionLink} target="_blank" rel="noopener noreferrer" className={classes.dialogDescriptionLink}>Saiba mais</a>
									)}
								</DialogContentText>
								<ul className={classes.benefitsList}>
									{dialogContent.benefits.map((benefit, index) => (
										<li key={index} className={classes.benefitItem}>
											<Check className={classes.benefitItemIcon} />
											<Typography variant="body1" className={classes.benefitItemText}>{benefit}</Typography>
										</li>
									))}
								</ul>
								<Typography variant="h6" className={classes.planAddonsInformationText}>
									{dialogContent.resourceDescription}
								</Typography>
								<DialogActions className={classes.dialogActions}>
									<Button variant="contained" endIcon={loading ? <CircularProgress size={20} color={"inherit"} /> : null} className={classes.dialogActionPrimaryButton} disabled={loading} onClick={handleRedirectToSubscriptionTeam}>
										Falar com especialista
									</Button>
									{/* <Typography className={classes.termsOfUse} variant="caption" color="textSecondary">Ao clicar, você concorda com os <a className={classes.termsOfUseLink} href={letalkLinks.notionTermsOfService} target="_blank" rel="noopener noreferrer">termos de uso</a></Typography> */}
									<Button variant="text" className={classes.dialogActionSecondaryButton} onClick={handleCloseDialog}>
										Cancelar
									</Button>
								</DialogActions>
							</Grid>
						)}

						<Grid md={4} className={classes.imageContainer} item>
							<img
								alt="Mulher feliz segurando o celular na mão esquerda"
								className={classes.dialogImage}
								src={upsellDialogImg}
							/>
							<IconButton className={classes.closeButton} onClick={handleCloseDialog}>
								<Close />
							</IconButton>
						</Grid>
					</Grid>
				</DialogContent>
			</Dialog>
		</ThemeProvider>
	)
}

UpsellHandlerDialog.open = (props: UpsellHandlerDialogProps) => {
	renderComponent(
		props.type,
		<UpsellHandlerDialog
			{...props}
		/>
	)
}

export default UpsellHandlerDialog
